module.exports = __webpack_public_path__ + "static/img/blo1.7f9da107.png";